import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

//UI
import { Button, Modal, Table, Loader, Icon, Form, Divider, List, Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import HeaderCatalog from "../../../components/headerCatalog";
import ActiveIcon from "../../../components/activeIcon";
import GenericRateCell from "../../../components/rates/genericRateCell"
import StateRateCell from "../../../components/rates/stateRateCell"
import ChangeStateRateModal from "../../../components/rates/changeStateRateModal"

//Actions
import { initialStateCharterRate } from "../../../redux/actions/rates/charterRates/fetchCharterRate";
import { deleteCharterRate } from "../../../redux/actions/rates/charterRates/deleteCharterRate";
import { fetchCharterRateListCustom, initialStateCharterRateListCustom } from "../../../redux/slices/custom/rates/charterRate/customCharterRateList.slice"
// Resources
import { scrollToTop } from "../../resources/utils";

export default function CharterRateList() {
  const { t } = useTranslation();
  let actualDate = new Date();
  let currentYear = actualDate.getFullYear();
  let rateType = "";
  let yacht = "";
  let days = "all";
  let state = 1;

  const charterRateFilters = JSON.parse(localStorage.getItem("charterRateFilters"));
  if (charterRateFilters) {
    currentYear = charterRateFilters.year;
    rateType = charterRateFilters.rate;
    yacht = charterRateFilters.yacht;
    days = charterRateFilters.days;
    state = charterRateFilters.state;
  }

  const { register, handleSubmit, errors, getValues } = useForm();

  const charterRateStateCustom = useSelector((state) => state.customCharterRateList);
  const charterRateState = useSelector((state) => state.charterRateReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCharterRateListCustom({ year: currentYear, rate_id: rateType, yacht_id: yacht, days: days, state: state }));
    scrollToTop();
    return () => {
      dispatch(initialStateCharterRateListCustom())
      dispatch(initialStateCharterRate());
    };
  }, []);

  if (charterRateStateCustom.fetching || charterRateState.fetching) {
    return <Loader active inline />;
  }

  if (charterRateState.message === "resource deleted successfully") {
    dispatch(fetchCharterRateListCustom({ year: getValues("year"), rate_id: getValues("rate_id"), yacht_id: getValues("yacht_id"), days: getValues("days"), state: getValues("state") }));
    dispatch(initialStateCharterRate());
  }

  if (charterRateState.message === "resource updated successfully") {
    dispatch(fetchCharterRateListCustom({ year: getValues("year"), rate_id: getValues("rate_id"), yacht_id: getValues("yacht_id"), days: getValues("days"), state: getValues("state") }));
    dispatch(initialStateCharterRate());
  }

  const onSubmit = (data) => {
    let charterRateFilters = {
      year: getValues("year"),
      rate: getValues("rate_id"),
      yacht: getValues("yacht_id"),
      days: getValues("days"),
      state: getValues("state")
    };
    localStorage.setItem("charterRateFilters", JSON.stringify(charterRateFilters));
    dispatch(fetchCharterRateListCustom(data));
  };

  const handleDeleteCharterRate = (charterRate_id) => {
    dispatch(deleteCharterRate(charterRate_id));
  };

  return (
    <>
      {charterRateState.error ? (
        <Message negative content={t(charterRateState.error)} />
      ) : (
        ""
      )}
      <HeaderCatalog title={t("charter_title")} message={charterRateStateCustom.message} to="/charterRates_new" />
      <Divider />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group widths="equal">
          <Form.Field>
            <label>{t("general_year")}</label>
            <select name="year" defaultValue={currentYear} aria-expanded="true" ref={register}>
              {charterRateStateCustom.years.map((year, index) => (
                <option key={index} value={year.year}>{year.year}</option>
              ))}
            </select>
          </Form.Field>
          <Form.Field required>
            <label>{t("general_rateType")}</label>
            <select name="rate_id" defaultValue={rateType} aria-expanded="true" ref={register({ required: true })}>
              <option />
              {charterRateStateCustom.rates.map((rateType) => (
                <option key={rateType.id} value={rateType.id}>{t(rateType.name)}</option>
              ))}
            </select>
            {errors.rate_id && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field required>
            <label>{t("general_yacht")}</label>
            <select name="yacht_id" defaultValue={yacht} aria-expanded="true" ref={register({ required: true })}>
              <option />
              {charterRateStateCustom.yachts.map((yacht) => (
                <option key={yacht.id} value={yacht.id}>{yacht.name}</option>
              ))}
            </select>
            {errors.rate_id && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field>
            <label>{t("general_days")}</label>
            <select name="days" defaultValue={days} aria-expanded="true" ref={register}>
              <option value="all">{t("all")}</option>
              {charterRateStateCustom.days.map((day, index) => (
                <option key={index} value={day.number_days}>{t(day.number_days)}</option>
              ))}
            </select>
          </Form.Field>
          <Form.Field>
            <label>{t("charter_state")}</label>
            <select name="state" defaultValue={state} aria-expanded="true" ref={register}>
              <option value="all">{t("all")}</option>
              <option value={1}>{t("active_tag")}</option>
              <option value={0}>{t("inactive_tag")}</option>
            </select>
          </Form.Field>
          <Form.Field>
            <label>&nbsp;</label>
            <Button type="submit" loading={charterRateStateCustom.fetching ? true : false} color="green"><Icon name='search' />{t("search_button")}</Button>
          </Form.Field>
        </Form.Group>
      </Form>

      {charterRateStateCustom.charterRates !== undefined ? (
        <Table color="blue" >
          <Table.Body>
            {charterRateStateCustom.charterRates.map((charterRate) => (
              <>
                <Table.Row>
                  <Table.Cell colSpan='8'>
                    <div className="flex justify-between">
                      <div className=" flex flex-col p-2 ">
                        <h1 className="text-[18px]">{charterRate.yacht}</h1>
                        <p className="font-semibold text-[15px] mt-[-13px]">{t("general_days")}: {charterRate.days}</p>
                        <StateRateCell activation_date={charterRate.activation_date} inactivation_date={charterRate.inactivation_date} reason_deactivation={charterRate.reason_deactivation} />
                      </div>
                      <div className=" flex items-center pr-6">
                        <List size="large">
                          <List.Item>
                            <List.Icon color='red' name={charterRate.airplane_ticket === 1 ? 'plane' : 'dont'} />
                            <List.Content>
                              <List.Description>{charterRate.airplane_ticket === 1 ? t("general_priceInclude") : t("general_priceNotInclude")} </List.Description>
                            </List.Content>
                          </List.Item>
                        </List>
                      </div>
                    </div>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell>{t("charter_year")}</Table.HeaderCell>
                  <Table.HeaderCell>{t("charter_rateType")}</Table.HeaderCell>
                  <Table.HeaderCell>{t("charter_clientRate")}</Table.HeaderCell>
                  <Table.HeaderCell>{t("charter_operatorRate")}</Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                </Table.Row>

                <Table.Row key={charterRate.id} className='no-row-borders'>
                  <Table.Cell collapsing><ActiveIcon active={charterRate.active} /></Table.Cell>
                  <Table.Cell>{charterRate.year}</Table.Cell>
                  <Table.Cell>{t(charterRate.rate)}</Table.Cell>
                  <Table.Cell><GenericRateCell rate={charterRate.rate_client} ticket={charterRate.airplane_ticket} /></Table.Cell>
                  <Table.Cell><GenericRateCell rate={charterRate.rate_operator} ticket={charterRate.airplane_ticket} /></Table.Cell>
                  <Table.Cell collapsing>
                    {charterRate.active != false ? (
                      <ChangeStateRateModal stateRate={charterRate} stateError={charterRateState.error} typeRate="CharterRate" />
                    ) : (
                      null
                    )}
                    {(!charterRate.active && !charterRate.reason_deactivation) && (
                      <>
                        <Link to={`/charterRates/${charterRate.id}`}><Button circular color='blue' icon='pencil alternate' /></Link>
                        <Modal
                          trigger={
                            <Button circular color='red' icon='trash alternate' />
                          }
                          content={t("general_delete")}
                          actions={[
                            t("canceled_button"),
                            {
                              key: "eliminar",
                              content: t("delete_button"),
                              className: "delete_button icon_color",
                              onClick: () => handleDeleteCharterRate(charterRate.id),
                            },
                          ]}
                          size="tiny"
                        />
                      </>)}
                  </Table.Cell>
                </Table.Row>
              </>
            ))}
          </Table.Body>
        </Table>
      ) : (
        ""
      )}
    </>
  );
}
